function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const PackageIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 4.6l-8-4c-.8-.4-1.8-.4-2.7 0l-8 4C1.6 5.1 1 6.1 1 7.2v9.5c0 1.1.6 2.2 1.7 2.7l8 4c.4.2.9.3 1.3.3.5 0 .9-.1 1.3-.3l8-4c1-.5 1.7-1.5 1.7-2.7V7.2c0-1.1-.6-2.1-1.7-2.6zm-9.7-2.3c.1-.1.3-.1.4-.1.2 0 .3 0 .4.1L19.8 6 17 7.4 9.2 3.5l2.4-1.2zm.4 7.6L4.2 6 7 4.6l7.8 3.9L12 9.9zm-8.5 7.8c-.3-.2-.5-.6-.5-.9V7.6l8 4v9.8l-7.5-3.7zm16.9 0L13 21.4v-9.8l8-4v9.2c0 .4-.2.7-.6.9z"
  }));
};
export default PackageIcon;